import React from 'react';
import EditField from '../../../../../components/Forms/EditField';
import Radio from '../../../../../components/Forms/Radio';
import FormGroup from '../../../../../components/Forms/FormGroup';
import { defaultTo, path } from 'ramda';
import { withFormik } from 'formik';
import Select from 'react-select';
import cn from 'classnames';

import image from '../../../../../../images/donation-visual.png';
import styles from './styles.m.scss';

import { handleError, handleSuccess } from '../../../../../util/forms';
import { apiUpdateRegistration } from '../../../../../api/registration';

import Footer from '../../../../../components/Accordion/Footer';
import * as yup from 'yup';

const Donation = ({
  donations,
  errors,
  touched,
  values,
  handleBlur,
  handleChange,
  handleSubmit,
  isSubmitting,
  isValid,
  status,
  setFieldValue,
  setStep,
  step,
}) => {
  return (
    <form>
      <img className={cn('mb-5', styles.dividingImg)} src={image} />
      <h2 className={styles.stepHeader}>Lend Your Support</h2>
      <p>
        Your gift, no matter the size, helps Sage Financial Solutions
        <sup>®</sup> continue to set the standard, providing scholarships, expanding our professional development
        programs and providing more effective resources to achieve our mission and vision.
      </p>
      <p>
        Sage Financial Solutions is a 501(c)(3) organization with Federal Tax ID 34-2017326. Your donation is tax deductible to the fullest
        extent permitted by law.
      </p>
      <FormGroup label="Donation option">
        <Select
          simpleValue
          onChange={(value) => setFieldValue('donationId', value)}
          options={donations.map((donation) => ({ value: donation.id, label: donation.name }))}
          value={values.donationId}
        />
        {values.donationId == '3' && (
          <div className="mt-4">
            <p>
              To recognize your support of the future leaders in our field, we would like to list the names of all
              Student Scholarship donors in the Sage Financial Solutions Symposium program. Please indicate below if you are comfortable
              with being recognized or if you would prefer to remain anonymous.
            </p>
            <Radio
              name="anonymous"
              value="0"
              label="List my name in Symposium Program"
              checked={values.anonymous}
              onBlur={handleBlur}
              onChange={handleChange}
            />
            <Radio
              name="anonymous"
              value="1"
              label="Keep My Donation Anonymous"
              checked={values.anonymous}
              onBlur={handleBlur}
              onChange={handleChange}
            />
          </div>
        )}
      </FormGroup>
      {values.donationId > 0 && (
        <FormGroup label="Donation amount">
          <Radio
            name="donationAmount"
            value="25.00"
            label="$25.00"
            checked={values.donationAmount}
            onBlur={handleBlur}
            onChange={handleChange}
          />
          <Radio
            name="donationAmount"
            value="50.00"
            label="$50.00"
            checked={values.donationAmount}
            onBlur={handleBlur}
            onChange={handleChange}
          />
          <Radio
            name="donationAmount"
            value="100.00"
            label="$100.00"
            checked={values.donationAmount}
            onBlur={handleBlur}
            onChange={handleChange}
          />
          <Radio
            name="donationAmount"
            value="250.00"
            label="$250.00"
            checked={values.donationAmount}
            onBlur={handleBlur}
            onChange={handleChange}
          />
          <Radio
            name="donationAmount"
            value="500.00"
            label="$500.00"
            checked={values.donationAmount}
            onBlur={handleBlur}
            onChange={handleChange}
          />
          <Radio
            name="donationAmount"
            value="other"
            label={
              <EditField
                block
                name="donationAmountOther"
                type="number"
                value={values.donationAmountOther}
                onBlur={handleBlur}
                onChange={handleChange}
              />
            }
            checked={values.donationAmount}
            onBlur={handleBlur}
            onChange={handleChange}
          />
        </FormGroup>
      )}
      <Footer
        step={step}
        setStep={setStep}
        isValid={isValid}
        isSubmitting={isSubmitting}
        handleSubmit={handleSubmit}
        skipBtn={
          <button
            type="button"
            className="btn btn-secondary mx-3"
            onClick={() => {
              Promise.resolve(setFieldValue('donationId', 0, false)).then(handleSubmit);
            }}
          >
            No thank you
          </button>
        }
      />
    </form>
  );
};

export default withFormik({
  handleSubmit: (payload, formProps) => {
    const { props } = formProps;

    if (payload.donationAmount == 'other') {
      payload.donationAmount = Number(payload.donationAmountOther);
    }

    apiUpdateRegistration(props.registration.id, { stepName: props.name, ...payload })
      .then(({ data }) => props.updateRegistration({ ...data, donations: defaultTo([], data.donations) }))
      .then(() => handleSuccess(formProps))
      .then(() => props.setStep(props.step + 1))
      .catch((err) => handleError(formProps, err));
  },
  mapPropsToValues: ({ registration }) => ({
    anonymous: defaultTo('', path(['donations', 0, 'anonymous'], registration)),
    donationId: defaultTo('', path(['donations', 0, 'productId'], registration)),
    donationAmount: defaultTo('', path(['donations', 0, 'finalPrice'], registration)),
    donationAmountOther: defaultTo('', path(['donations', 0, 'finalPrice'], registration)).toString(),
  }),
  validationSchema: () =>
    yup.object().shape({
      donationId: yup.number().required(),
      donationAmount: yup.mixed().when('donationId', (donationId, schema) => {
        return donationId == 0 ? schema : schema.required();
      }),
      donationAmountOther: yup.number().when('donationAmount', (donationId, schema) => {
        return donationId != 'other' ? schema : schema.required();
      }),
    }),
  isInitialValid: ({ initialValues, validationSchema }) => validationSchema().isValidSync(initialValues),
  validateOnChange: true,
})(Donation);
